import React from "react";
import { FaVideo } from "react-icons/fa6";
import { IoBookSharp } from "react-icons/io5";
import { FaHeadphones } from "react-icons/fa6";
import { LuNotepadText } from "react-icons/lu";
import { FaDownload } from "react-icons/fa";
import source1 from "../asset/courses/AI.png";
import source2 from "../asset/courses/DEV.png";
import source3 from "../asset/courses/Data.png";
import logo from '../asset/logowhite.png'
import { FaArrowLeft } from "react-icons/fa";
import { FaRegShareSquare } from "react-icons/fa";
const Resourses = () => {
  const resources = [
    {
      icon: <IoBookSharp />, // or use an actual image/icon if you have one
      title: "E-books & Guide",
      subtitle: "Free video content from our expert instructors",
      badge: "50+ Resources",
      buttonText: "Browse All",
    },
    {
      icon: <FaVideo />, // or use an actual image/icon if you have one
      title: "Video Tutorials",
      subtitle: "Free video content from our expert instructors",
      badge: "50+ Resources",
      buttonText: "Browse All",
    },
    {
      icon: <FaHeadphones />, // or use an actual image/icon if you have one
      title: "Webinars",
      subtitle: "Free video content from our expert instructors",
      badge: "50+ Resources",
      buttonText: "Browse All",
    },
    {
      icon: <LuNotepadText />, // or use an actual image/icon if you have one
      title: "White Papers",
      subtitle: "Free video content from our expert instructors",
      badge: "50+ Resources",
      buttonText: "Browse All",
    },
  ];
  const featuredresources = [
    {
      id: 1,
      title: "Complete Guide to DevOps Implementation",
      description:
        "A comprehensive 100-page guide covering DevOps best practices, tools, and implementation strategies for enterprise.",
      type: "E-Book",
      tag: "DevOps",
      downloads: "25K+",
      image: source2,
    },
    {
      id: 2,
      title: "Data Science Fundamentals",
      description:
        "A 12-part video series covering Python, machine learning, and data visualization techniques for beginners.",
      type: "Video Series",
      tag: "Data Science",
      downloads: "25K+",
      image: source1,
    },
    {
      id: 3,
      title: "Cloud Migration Strategy Report 2025",
      description:
        "Latest trends and strategies for successful cloud migration, including case studies from Fortune 500 companies.",
      type: "White paper",
      tag: "Cloud Computing",
      downloads: "25K+",
      image: source3,
    },
  ];
  const webinars = [
    {
      title: "Full Stack Web Developer Masters Program",
      date: "August 20, 2025",
      time: "3:00 PM EST",
      speaker: "Dr. Sarah Johnson",
      badge: "Upcoming",
      registed: "450 registered",
    },
    {
      title: "Kubernetes Security Best Practices",
      date: "August 20, 2025",
      time: "3:00 PM EST",
      speaker: "Mike Chen",
      badge: "Upcoming",
      registed: "450 registered",
    },
    {
      title: "Building Scalable React Applications",
      date: "August 20, 2025",
      time: "3:00 PM EST",
      speaker: "Lisa Rodriguez",
      badge: "Upcoming",
      registed: "450 registered",
    },
  ];

  return (
    <div className="dark:bg-gray-900">
        <button
    onClick={() => window.history.back()}
    className="fixed top-24 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700 lg:hidden"
    aria-label="Go back"
  >
    <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
  </button>
      <section className="bg-[#1C3664] dark:bg-gray-800 text-white py-20 text-center rounded">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 font-inter">
          Learning Resourses
        </h1>
        <p className="text-lg md:text-xl max-w-4xl mx-auto font-inter">
          Access Our Comprehensive library of free learing resourses including
          e-books,
          <br className="hidden md:block font-inter" />
          video tutorials, webinars, and and industry insights to accelerate
          your profession growth.
        </p>
      </section>
      {/* Top 4 Cards */}
      <div className="bg-gray-100 dark:bg-gray-900 pt-20 pb-20">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4 max-w-7xl mx-auto">
          {resources.map((res, idx) => (
            <div
              key={idx}
              className="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-100 dark:border-gray-700 border-l-4 border-l-[#163165] dark:border-l-blue-600 p-6 flex flex-col justify-between"
            >
              {/* Icon */}
              <div className="text-4xl text-yellow-500 mb-4">
                <p>{res.icon}</p>
              </div>

              {/* Title */}
              <h3 className="font-bold text-lg text-[#163165] dark:text-white">{res.title}</h3>

              {/* Subtitle */}
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">{res.subtitle}</p>

              {/* Badge */}
              <span className="mt-4 text-[12px] bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-3 py-1 rounded-full font-inter">
                {res.badge}
              </span>

              {/* Button */}
              <button className="mt-4 text-white w-full py-3 rounded-md font-semibold bg-[#1C3664] dark:bg-blue-700 hover:bg-blue-800 dark:hover:bg-blue-600 transition">
                {res.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>
      <section className="py-16 bg-gray-50 dark:bg-gray-900">
        <div className="max-w-6xl mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-900 dark:text-white mb-4 font-inter">
            Featured Resources
          </h1>
          <p className="text-center text-gray-600 dark:text-gray-400 mb-10">
            Our 450 registered and highly-rated learning materials, curated by
            industry experts
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            {featuredresources.map((res) => (
              <div
                key={res.id}
                className="bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden flex flex-col border-blue-900 dark:border-blue-700 border-[1px]"
              >
                <div className="relative">
                  <img
                    src={res.image}
                    alt={res.title}
                    className="w-full h-48 object-cover"
                  />
                  <span className="absolute top-2 left-2 bg-white dark:bg-gray-700 text-xs font-semibold px-2 py-1 rounded">
                    {res.type}
                  </span>
                  <span className="absolute top-2 right-2 bg-gray-700 dark:bg-gray-600 text-white text-xs px-2 py-1 rounded">
                    {res.tag}
                  </span>
                </div>

                {/* Card Content */}
                <div className="flex flex-col flex-1 p-5">
                  <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                    {res.title}
                  </h2>
                  <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
                    {res.description}
                  </p>

                  <div className="mt-auto">
                    <div className="flex items-center text-gray-500 dark:text-gray-400 text-sm mb-4">
                      <FaDownload className="mr-2" />
                      {res.downloads} downloads
                    </div>

                    <button className="w-full bg-[#1C3664] dark:bg-blue-700 hover:bg-blue-800 dark:hover:bg-blue-600 text-white py-3 px-4 rounded flex items-center justify-center gap-2">
                      <FaDownload />
                      Download Free
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-[#f7f9fc] dark:bg-gray-800 py-10 px-4">
        <h1 className="text-center text-[34px] font-bold text-[#0E3A6D] dark:text-white mb-2">
          Upcoming Webinars
        </h1>
        <p className="text-center text-[18px] font-semibold text-[#0E3A6D] dark:text-gray-300 mb-8">
          Join our live sessions with industry experts and expand your knowledge
        </p>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto">
          {webinars.map((program, idx) => (
            <div
              key={idx}
              className="relative bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg p-6 shadow-md after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-full after:h-full after:border-r-[10px] after:border-b-[10px] after:border-r-[#2d63dd] after:border-b-[#2d63dd] after:rounded-lg after:z-0"
            >
              <div className="relative z-10">
                {/* Top Row */}
                <div className="flex justify-between items-center mb-3">
                  <span className="text-[10px] text-white bg-[#2d63dd] px-2 py-1 rounded font-medium">
                    {program.badge}
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    {program.registed}
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-[#1c3664] dark:text-white text-[20px] font-bold mb-4 leading-snug">
                  {program.title}
                </h3>

                {/* Details */}
                <div className="text-sm text-[#1c3664] dark:text-gray-300 space-y-1 mb-5">
                  <p>
                    <span className="font-medium text-gray-600 dark:text-gray-400">Date:</span>{" "}
                    <span className="font-semibold">{program.date}</span>
                  </p>
                  <p>
                    <span className="font-medium text-gray-600 dark:text-gray-400">Time:</span>{" "}
                    <span className="font-semibold">{program.time}</span>
                  </p>
                  <p>
                    <span className="font-medium text-gray-600 dark:text-gray-400">Speaker:</span>{" "}
                    <span className="font-semibold">{program.speaker}</span>
                  </p>
                </div>

                {/* Button */}
                <button className="mt-2 flex justify-center items-center gap-2 text-white w-full py-3 rounded-md font-semibold bg-[#1C3664] dark:bg-blue-700 hover:bg-blue-800 dark:hover:bg-blue-600 transition">
                  Register Free <FaRegShareSquare />
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="bg-[#0E3A6D] dark:bg-gray-800 text-white py-20 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 font-inter">
          Stay Updated
        </h1>
        <p className="text-lg md:text-2xl max-w-4xl mx-auto font-inter">
          Subscribe to our news letter never miss new resourses
          <br className="hidden md:block font-inter" />
       webinars, and industry insights 
       
        </p>
        <div className="flex p-6 justify-center items-center gap-2">
  <input
    className="p-3 rounded-[5px] bg-white dark:bg-gray-700 text-gray-800 dark:text-white placeholder-gray-400 dark:placeholder-gray-300 w-64"
    placeholder="Enter your email"
  />
  <button className="bg-[#1C3664] hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 text-white  rounded-[5px] px-4 py-3 font-semibold">
    Subscribe
  </button>
</div>

       
      </section>    
      {/* <div className="bg-[#0E3A6D] dark:bg-gray-800 text-white py-20 text-center">
        <div className="inline-block mb-12">
        <img
          src={logo}
          alt="Skillara logo"
          className="mx-auto mb-4"
          style={{ maxWidth: "80%" }}
        />
      </div>

      <h3 className="text-blue-300 dark:text-blue-400 font-extrabold text-3xl mb-4">
        Enroll, Learn, Grow, Repeat!
      </h3>
      <p className="text-white mb-6 text-lg">
        Get ready to achieve your learning goals with Skillara
      </p>

      <button className="bg-blue-500 dark:bg-blue-600 hover:bg-blue-600 dark:hover:bg-blue-700 text-white rounded-full px-8 py-3 font-semibold transition">
        View All Premium Courses
      </button>
      </div>    */}
    </div>
  );
};

export default Resourses;